import request from '@/util/http.js'
// 员工列表
export const getPersonnel = (query) => {
  return request({
    url: '/hr/getPersonnel',
    method: 'get',
    params: query
  })
}
// 员工列表不分页
export const getPersonnelList = () => {
  return request({
    url: '/hr/getPersonnelList',
    method: 'get',
  })
}
// 导出员工列表
export const exportPersonnel = (data) => {
  return request({
    url: '/hr/exportPersonnel',
    method: 'post',
    data
  })
}
// 添加员工
export const addPersonnel = (data) => {
  return request({
    url: '/hr/addPersonnel',
    method: 'post',
    data: data
  })
}
// 编辑员工
export const editPersonnel = (data) => {
  return request({
    url: '/hr/editPersonnel',
    method: 'post',
    data: data
  })
}
// 删除员工
export const delPersonnel = (data) => {
  return request({
    url: '/hr/delPersonnel',
    method: 'delete',
    data: data
  })
}
// 根据id查询员工信息
export const getPersonnelInfoById = (query) => {
  return request({
    url: '/hr/getPersonnelInfoById',
    method: 'get',
    params: query
  })
}
//  导出人员表格
export const exportPersonnelReport = (data) => {
  return request({
    url: '/hr/exportPersonnelReport',
    method: 'post',
    data: data
  })
}
// 获取年度分析数据
export const annualAnalysis = () => {
  return request({
    url: '/hr/annualAnalysis',
    method: 'get',
  })
}

// 获取人员分析
export const personnelAnalysis = () => {
  return request({
    url: '/hr/personnelAnalysis',
    method: 'get',
  })
}
// 离职员工列表
export const getResignPersonnel = (query) => {
  return request({
    url: '/hr/resignPersonnel',
    method: 'get',
    params: query
  })
}
// 编辑员工状态
export const changeStatus = (data) => {
  return request({
    url: '/hr/changeStatus',
    method: 'post',
    data: data
  })
}
// 还原离职员工
export const reductionPersonnel = (data) => {
  return request({
    url: '/hr/reductionPersonnel',
    method: 'post',
    data: data
  })
}
// 根据id查询离职员工信息
export const getReductionPersonnelInfoById = (query) => {
  return request({
    url: '/hr/getReductionPersonnelInfoById',
    method: 'get',
    params: query
  })
}
//获取近三天转正员工列表
export const recentlyCorrected = () => {
  return request({
    url: '/hr/recentlyCorrected',
    method: 'get',
  })
}
// 外线员工列表
export const getOutsourcingList = (query) => {
  return request({
    url: '/hr/outsourcingList',
    method: 'get',
    params: query
  })
}// 添加员工
export const addOutsourcing = (data) => {
  return request({
    url: '/hr/addOutsourcing',
    method: 'post',
    data: data
  })
}
// 编辑员工
export const editOutsourcing = (data) => {
  return request({
    url: '/hr/editOutsourcing',
    method: 'post',
    data: data
  })
}
// 删除员工
export const delOutsourcing = (data) => {
  return request({
    url: '/hr/delOutsourcing',
    method: 'delete',
    data: data
  })
}
// 根据id查询员工信息
export const getOutsourcingInfoById = (query) => {
  return request({
    url: '/hr/getOutsourcingInfoById',
    method: 'get',
    params: query
  })
}